import React from 'react';
import { useSelector } from 'react-redux';
import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import { OperatorTypeDetails } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import AnalogComputedChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/AnalogComputedChannel/AnalogComputedChannel';
import DigitalParticulateTemperatureFaultChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/DigitalParticulateTemperatureFaultChannel/DigitalParticulateTemperatureFaultChannel';
import IntegerAsBooleanChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/IntegerAsBooleanChannel/IntegerAsBooleanChannel';
import BooleanChannel from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/BooleanChannel/BooleanChannel';
import ExtremeTemperatureFaultChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/ExtremeTemperatureFaultChannel/ExtremeTemperatureFaultChannel';
import BaseTemperatureChannel
  from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/BaseTemperatureChannel/BaseTemperatureChannel';
import {
  selectSensorsData,
  selectThresholdOperator,
  selectThresholdValue,
} from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import { getAnalogComputedUnit } from '../../../../redux/slices/deviceList/deviceListHelperUtils';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import { selectSensorMap } from '../../../../redux/slices/deviceList/deviceListSlice';

function IndependentThresholdSummary() {
  const selectedSensorsData = useSelector(selectSensorsData);
  const selectedChannel = selectedSensorsData.selectedChannels[0];
  const channel = ChannelService.getChannelFromChannelKey(selectedChannel);

  const thresholdValue = useSelector(selectThresholdValue);
  const operator = useSelector(selectThresholdOperator);
  const sensorMap = useSelector(selectSensorMap);
  const sessionInformation = useSelector(selectSessionInformation);

  const getOperatorLabel = () => {
    const details = OperatorTypeDetails[operator];
    return details ? details.label.replace('is', '').trim() : operator;
  };

  const getUnits = () => {
    if (channel instanceof AnalogComputedChannel) {
      return getAnalogComputedUnit(
        {
          macAddress: '',
          channelGroupTypeId: '',
          channelGroupIndex: '',
        },
        sensorMap,
      );
    }

    const scale = channel instanceof BaseTemperatureChannel
      ? sessionInformation.temperatureScale
      : sessionInformation.airSpeedScale;

    return channel.getUnits ? channel.getUnits({ scale, airSpeedScale: sessionInformation.airSpeedScale }) : '';
  };

  const renderBooleanSummary = () => {
    if (
      channel instanceof DigitalParticulateTemperatureFaultChannel
    ) {
      const label = thresholdValue === 1
        ? channel.falseDisplayValue
        : channel.trueDisplayValue;

      return <span>{label}</span>;
    }

    if (
      channel instanceof ExtremeTemperatureFaultChannel
    ) {
      const label = thresholdValue === 1
        ? 'No Fault'
        : 'Fault';
      return (
        <span>
          is
          {' '}
          {label}
        </span>
      );
    }

    if (channel instanceof IntegerAsBooleanChannel) {
      return (
        <span>
          {thresholdValue === 1
            ? channel.falseDisplayValue
            : channel.trueDisplayValue}
        </span>
      );
    }

    return (
      <span>
        {channel.getDisplayValue(thresholdValue)}
      </span>
    );
  };

  const renderNumericSummary = () => (
    <span>
      {getOperatorLabel()}
      {' '}
      {thresholdValue}
      {' '}
      {getUnits()}
    </span>
  );

  return (
    <div className="read-only-threshold-summary">
      <strong>
        {channel.displayName}
        :
        {' '}
      </strong>
      {(channel instanceof BooleanChannel
                || channel instanceof IntegerAsBooleanChannel
          || channel instanceof ExtremeTemperatureFaultChannel)
        ? renderBooleanSummary()
        : renderNumericSummary()}
    </div>
  );
}

export default IndependentThresholdSummary;
